<div class="nhai-toc">
  <div class="nhai-toc-title">NHAI layers</div>
  <div class="nhai-group" *ngFor="let group of groups">
    <div class="nhai-group-head" (click)="toggleExpanded(group.id)">
      <span class="nhai-caret">{{ isExpanded(group.id) ? '▼' : '▶' }}</span>
      <label class="nhai-check" *ngIf="group.id !== 'basemaps'" (click)="$event.stopPropagation()">
        <input
          type="checkbox"
          [checked]="groupState(group) === 'all'"
          [indeterminate]="groupState(group) === 'some'"
          (change)="toggleGroup(group, $any($event.target).checked, $event)"
        />
      </label>
      <span class="nhai-name">{{ group.label }}</span>
    </div>
    <ul class="nhai-leaves" *ngIf="isExpanded(group.id)">
      <li *ngFor="let leaf of group.children" [class.stub]="leaf.source === 'stub'">
        <label *ngIf="leaf.source === 'basemap'" class="nhai-leaf">
          <input
            type="radio"
            name="nhai-basemap"
            [checked]="selectedBaseMap === leaf.basemapKey"
            (change)="pickBasemap(leaf)"
          />
          <span>{{ leaf.label }}</span>
        </label>
        <label *ngIf="leaf.source !== 'basemap'" class="nhai-leaf" [title]="leaf.stubHint || leaf.label">
          <input
            type="checkbox"
            [checked]="leafOn(leaf)"
            [disabled]="leaf.source === 'stub'"
            (change)="toggleLeaf(leaf, $any($event.target).checked, $event)"
          />
          <span>{{ leaf.label }}</span>
          <em *ngIf="count(leaf) != null">{{ count(leaf) }}</em>
        </label>
      </li>
    </ul>
  </div>
</div>
